import React from 'react';

import { Container, Description, Title } from './styles';

export type PageHeaderProps = {
  title: string;
  description?: string;
  className?: string;
};

const PageHeader = ({
  title,
  description,
  className,
}: PageHeaderProps): JSX.Element => {
  return (
    <Container className={className}>
      <Title>{title}</Title>
      {description && <Description>{description}</Description>}
    </Container>
  );
};

export default PageHeader;
